<template>
  <modal class="modal--welcomeback modal--zero-balance" :modal-key="'block_user_modal'" @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_block_user_title }}</h1>
      <img class="pinicon" src="static/images/block_icon.svg" alt="">
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_modals_block_user_are_you_sure }}</p>
      <div class="other_user_mod">
        <img :src="getSelectedUser.avatar" alt="">
        <span>{{ getSelectedUser.username }}</span>
      </div>
      <p>{{ getTranslations.home_modals_block_user_if_you_block }}</p>
      <p>{{ getTranslations.home_modals_block_user_you_can_unblock }}</p>
    </template>
    <div class="modal__footer" slot="footer">
      <a href="#"
         @click.prevent="block"
         class="btn2 btn2--std btn2--small modal_btn_margin">
        {{ getTranslations.home_modals_block_user_block }}
      </a>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'block-user',
  components: {
    Modal,
  },
  methods: {
    ...mapMutations('users', [
      'refreshSelectedUser',
    ]),
    ...mapActions('users', [
      'markBlockedUser',
    ]),
    block() {
      this.markBlockedUser(this.getSelectedUser.username);
      this.refreshSelectedUser();
      this.$emit('close');
    },
  },
  computed: {
    ...mapGetters('users', [
      'getSelectedUser',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/users/BlockUser.vue